<template>
  <div>
    <div class="row">
      <span class="font-weight-bold">
        Induló bérleti díj
      </span>
    </div>
    <div class="row mb-2">
      <div class="col-12 initial-deposit-slider">
        <vue-slider
          :value="initialPaymentPercent"
          :height="8"
          :dot-size="20"
          :min="0"
          :max="40"
          :tooltip="false"
          @input="setInitialPaymentPercent"
        />
        <span>{{ initialPaymentPercent }} %</span>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { Component } from 'vue-property-decorator';
  import { namespace } from 'vuex-class';

  const configuratorModule = namespace('configurator');

  @Component
  export default class InitialPaymentSelector extends Vue {
    @configuratorModule.Getter('getInitialPaymentPercent') initialPaymentPercent;
    @configuratorModule.Mutation('setInitialPaymentPercent') setInitialPaymentPercent;
  }
</script>
